"use client";
import React from "react";
import { SingleProductImageFocused } from "../singleProduct/singleProductImageFocused";
import { SingleProductDescriptionFocused } from "../singleProduct/singleProductDescriptionFocused";
import Link from "next/link";

export interface LandingProductsProps {
  products: any;
  selectedTemplate: string;
  category: string;
  isServiceMerchant: boolean;
  isRestaurantMerchant: boolean;
  merchant: any;
}

export function LandingProducts({
  products = [],
  selectedTemplate,
  category = "All",
  isServiceMerchant,
  isRestaurantMerchant,
  merchant,
}: LandingProductsProps) {
  const merchantMeta = merchant.merchantMeta;
  const merchantColor = merchantMeta.colorPalette?.color;
  const getProductHref = (productId: string) => {
    if (isServiceMerchant) return `/services/${productId}`;
    if (isRestaurantMerchant || merchant.isEssentialMerchant)
      return `/menu/${productId}`;
    return `/${productId}`;
  };
  const landingProductsText = landingProductsHeaderText(
    isServiceMerchant,
    isRestaurantMerchant
  );

  return (
    <div
      className={[
        "bg-white",
        "p-6",
        "my-6",
        "rounded-lg",
        "mx-8",
        `${
          selectedTemplate.toLowerCase() == "image focused" &&
          "border border-gray-300"
        }`,
      ].join(" ")}
    >
      <div
        className={[
          "flex",
          "flex-col",
          "justify-between",
          "sm:flex-row",
          "gap-6",
        ].join(" ")}
      >
        <p className="font-semibold text-[30px] leading-[45px]">
          {landingProductsText} {category}
        </p>
        <LandingProductsButton
          {...{
            isServiceMerchant,
            isRestaurantMerchant,
            merchantColor,
          }}
        />
      </div>
      <div
        className={[
          "mt-6",
          "grid",
          "grid-cols-1",
          "gap-x-6",
          "gap-y-10",
          "sm:grid-cols-1",
          "lg:grid-cols-2",
          "xl:gap-x-8",
          `${
            selectedTemplate.toLowerCase() == "image focused" &&
            "grid-cols-2 sm:grid-cols-2 lg:grid-cols-4"
          }`,
          `${
            selectedTemplate.toLowerCase() == "description focused" &&
            " grid-cols-1 sm:grid-cols-1 lg:grid-cols-2"
          }`,
        ].join(" ")}
      >
        {selectedTemplate.toLowerCase() == "image focused" &&
          products.map((product: any) => (
            <Link href={getProductHref(product.id)} key={product.id}>
              <SingleProductImageFocused
                product={product}
                isRetailMerchant={merchant.isRetail}
              />
            </Link>
          ))}
        {selectedTemplate.toLowerCase() == "description focused" &&
          products.slice(0, 4).map((product: any) => (
            <Link href={getProductHref(product.id)} key={product.id}>
              <SingleProductDescriptionFocused
                product={product}
                key={product.id}
                isRetailMerchant={merchant.isRetail}
              />
            </Link>
          ))}
      </div>
    </div>
  );
}

const LandingProductsButton = ({
  isServiceMerchant,
  isRestaurantMerchant,
  merchantColor,
}: any) => {
  const buttonLabel = isServiceMerchant
    ? "View all services"
    : isRestaurantMerchant
    ? "View all items"
    : "View all products";

  const buttonHref = isServiceMerchant
    ? "/services"
    : isRestaurantMerchant
    ? "/menu/all"
    : "/all";

  return (
    <a href={buttonHref}>
      <div
        style={{ borderColor: merchantColor, color: merchantColor }}
        className={[
          "flex",
          "flex-row",
          "justify-center",
          "text-[#1A56DB] px-3 py-2.5 border border-solid rounded-lg font-medium text-sm leading-[21px]",
        ].join(" ")}
      >
        <p>{buttonLabel} &nbsp; &rarr;</p>
      </div>
    </a>
  );
};

const landingProductsHeaderText = (
  isServiceMerchant: boolean,
  isRestaurantMerchant: boolean
) => {
  return isServiceMerchant ? "Book" : isRestaurantMerchant ? "Order" : "Shop";
};
